import { Box, Flex } from '@chakra-ui/react';

import styles from './styles.module.css';
import HeadSkeleton from 'View/monitoring/component/skeleton/head-skeleton';
import ClockInSkeleton from 'View/monitoring/component/skeleton/clock-in-skeleton';
import LogDailySkeleton from 'View/monitoring/component/skeleton/log-daily-skeleton';
import ActiveOperatorsSkeleton from 'View/monitoring/component/skeleton/active-operators-skeleton';

const MonitoringSkeleton = () => {
  return (
    <Box className={styles['monitoring-skeleton__container']}>
      {/* Head */}
      <HeadSkeleton />
      <ClockInSkeleton />

      <Flex width="100%" justifyContent="space-between" gap="24px" mt="24px">
        <LogDailySkeleton />
        <ActiveOperatorsSkeleton />
      </Flex>
    </Box>
  );
};

export default MonitoringSkeleton;
